import { useEffect, useState } from "react";
import { useMainContext } from "../../../Context";
import { listMark, toggleMark } from "../../../Utils/Apis";

export const useBookMarks = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [markLoading, setMarkLoading] = useState(false);

  const { post } = useMainContext();
  const get = async () => {
    setLoading(true);
    const { data } = await post(listMark, {});
    setData(data);
    setLoading(false);
  };
  const toggle = async ads_id => {
    setMarkLoading(true);
    const { status } = await post(toggleMark, { ads_id });
    if (+status == 200) {
      setData({ ...data, mark: data.mark == "true" ? "false" : "true" });
    }
    setMarkLoading(false);
  };

  useEffect(() => {
    get();
  }, [markLoading]);

  return { data, loading, toggle, markLoading };
};
